import { render, staticRenderFns } from "./WSFontPicker.vue?vue&type=template&id=25b6f29a&"
import script from "./WSFontPicker.vue?vue&type=script&lang=js&"
export * from "./WSFontPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports